import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="page-container">
      <h1>Welcome to VRai3D</h1>
      <p>Your portal to amazing 3D worlds and models.</p>
      <Link to="/vr">
        <button>Enter VR Gallery</button>
      </Link>
      <br />
      <br />
      <Link to="/gallery">
        <button>View 2D Model Gallery</button>
      </Link>
    </div>
  );
};

export default Home;
